import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { siteParamsCreate, siteParamsDelete, siteParamsList, siteParamsUpdate } from '@/api/siteParams';
import { AppError } from '@/errors/appError';
import { isRequestCanceled } from '@/services/baseService';
import { ISiteParamsApiListResponse, ISiteParamUpdateParams, ISiteParamUpdateResponse } from '@/types/siteParams';

export const siteParamsService = {
    async listBySiteId(siteId: number, config?: AxiosRequestConfig): Promise<AxiosResponse<ISiteParamsApiListResponse>> {
        try {
            return await siteParamsList(siteId, config);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Site params API Error:', e);
            throw new AppError('Unable to load site params, request error', { cause: e });
        }
    },

    async create(params: ISiteParamUpdateParams): Promise<AxiosResponse<ISiteParamUpdateResponse>> {
        try {
            return await siteParamsCreate(params);
        } catch (e) {
            console.error('Site params create API Error:', e);
            throw new AppError('Unable to create site param, request error', { cause: e });
        }
    },

    async update(params: ISiteParamUpdateParams): Promise<AxiosResponse<ISiteParamUpdateResponse>> {
        try {
            return await siteParamsUpdate(params);
        } catch (e) {
            console.error('Site params update API Error:', e);
            throw new AppError('Unable to update site param, request error', { cause: e });
        }
    },

    async delete(params: ISiteParamUpdateParams): Promise<AxiosResponse<ISiteParamUpdateResponse>> {
        try {
            return await siteParamsDelete(params);
        } catch (e) {
            console.error('Site params delete API Error:', e);
            throw new AppError('Unable to delete site param, request error', { cause: e });
        }
    },
};
